import { UpdateLicenseDto } from '../../pages/users/api/dto/update/UpdateLicenseDto'
import { UpdateLicenseUI } from '../../pages/users/model/UpdateLicenseUI'
import VehicleLicenseType from '../vehicle/VehicleLicenseType'
import License from './License'

class UpdateLicense {
  private constructor(
    vehicleLicense: VehicleLicenseType,
    type: string,
    examFailNumber: number,
    description: string | undefined,
    successDate: Date | undefined,
    renewalDate: Date | undefined,
    licenseProtocolNumber: string | undefined,
    restricted: boolean,
    active: boolean,
  ) {
    this.vehicleLicense = vehicleLicense
    this.type = type
    this.examFailNumber = examFailNumber
    this.description = description ? description : ''
    this.successDate = successDate
    this.renewalDate = renewalDate
    this.licenseProtocolNumber = licenseProtocolNumber
      ? licenseProtocolNumber
      : ''
    this.restricted = restricted
    this.active = active
  }

  private readonly vehicleLicense: VehicleLicenseType
  private readonly type: string
  private examFailNumber: number
  private description: string
  private successDate?: Date
  private renewalDate?: Date
  private licenseProtocolNumber: string
  private readonly restricted: boolean
  private active: boolean

  getId(): string {
    return this.vehicleLicense.getId()
  }

  hasId(id: string): boolean {
    return this.vehicleLicense.getId() === id
  }

  getType(): string {
    return this.type
  }

  isActive() {
    return this.active
  }

  setActive(active: boolean) {
    this.active = active
  }

  isSuccess() {
    return this.successDate != null
  }

  update(updateLicense: UpdateLicense): void {
    this.examFailNumber = updateLicense.examFailNumber
    this.successDate = updateLicense.successDate
    this.renewalDate = updateLicense.renewalDate
    this.description = updateLicense.description
    this.licenseProtocolNumber = updateLicense.licenseProtocolNumber
  }

  toDto(): UpdateLicenseDto {
    return {
      type: this.vehicleLicense.getId(),
      examFailNumber: this.examFailNumber,
      description: this.description,
      success: this.isSuccess(),
      successDate: this.successDate,
      renewalDate: this.renewalDate,
      licenseProtocolNumber: this.licenseProtocolNumber,
    } satisfies UpdateLicenseDto
  }

  toUI(): UpdateLicenseUI {
    return {
      vehicleLicense: this.vehicleLicense,
      type: this.type,
      examFailNumber: this.examFailNumber,
      description: this.description,
      success: this.isSuccess(),
      successDate: this.successDate,
      renewalDate: this.renewalDate,
      licenseProtocolNumber: this.licenseProtocolNumber,
      active: this.active,
      restricted: this.restricted,
    } satisfies UpdateLicenseUI
  }

  static fromUpdateLicenseUI(updateLicenseUI: UpdateLicenseUI): UpdateLicense {
    return new UpdateLicense(
      updateLicenseUI.vehicleLicense,
      updateLicenseUI.type,
      updateLicenseUI.examFailNumber,
      updateLicenseUI.description,
      updateLicenseUI.successDate,
      updateLicenseUI.renewalDate,
      updateLicenseUI.licenseProtocolNumber,
      updateLicenseUI.restricted,
      updateLicenseUI.active,
    )
  }

  static fromLicense(license: License): UpdateLicense {
    const licenseUI = license.toLicenseUI()

    return new UpdateLicense(
      licenseUI.vehicleLicense,
      licenseUI.type,
      licenseUI.examFailNumber,
      licenseUI.description,
      licenseUI.successDate,
      licenseUI.renewalDate,
      licenseUI.licenseProtocolNumber,
      licenseUI.restricted,
      licenseUI.active,
    )
  }
}

export default UpdateLicense
